/**
 * The five state colors, as Tailwind classes, in one place so the cards, the
 * pips under each tech and the day bar can never disagree. Orange is used ONLY
 * for "needs a person" (threads/new-grid/mockup.html).
 */
import type { CardState } from "./card-state";

export const STATE_CARD_CLASS: Record<CardState, string> = {
    todo: "bg-card border-stone-300 dark:border-stone-600",
    there: "bg-sky-50 border-sky-600 dark:bg-sky-950 dark:border-sky-400",
    finished: "bg-emerald-50 border-emerald-50 dark:bg-emerald-950 dark:border-emerald-950",
    office: "bg-violet-50 border-violet-50 dark:bg-violet-950 dark:border-violet-950",
    person: "bg-orange-50 border-[#C86A00] border-2 dark:bg-orange-950 dark:border-orange-400",
};

/** Solid swatch for pips, the day bar and the color key. */
export const STATE_SWATCH_CLASS: Record<CardState, string> = {
    todo: "bg-stone-300 dark:bg-stone-500",
    there: "bg-sky-600 dark:bg-sky-400",
    finished: "bg-emerald-600 dark:bg-emerald-400",
    office: "bg-violet-600 dark:bg-violet-400",
    person: "bg-[#C86A00] dark:bg-orange-400",
};

/** Device blocks inside a card take the state's ink so they read as one. */
export const STATE_DEVICE_CLASS: Record<CardState, string> = {
    todo: "bg-stone-400 dark:bg-stone-500",
    there: "bg-sky-600 dark:bg-sky-400",
    finished: "bg-emerald-600 dark:bg-emerald-400",
    office: "bg-violet-600 dark:bg-violet-400",
    person: "bg-[#C86A00] dark:bg-orange-400",
};

/** Text on the orange "needs you" chips. #C86A00 on orange-50 is 3.9:1, so
 *  the ink is the darker orange-800 and the fill carries the brand orange. */
export const PERSON_INK = "text-orange-800 dark:text-orange-200";
